import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../components/Login.vue";
// 工作台
import WorkPlat from "../components/backlog/WorkPlat.vue";

// backLog 
import ManagerPage from "../components/ManagerPage.vue";

// 我的网盘
import MyDoc from "../components/backlog/MyNetworkDisk/myDoc.vue";
import MyShare from "../components/backlog/MyNetworkDisk/myShare.vue";
import ReceiveShare from "../components/backlog/MyNetworkDisk/receiveShare.vue";
import PatfromShare from "../components/backlog/MyNetworkDisk/patfromShare.vue";

// 我的项目
import ManagementProject from "../components/backlog/MyProjectManagement/management.vue";
import ManagementProjectDetail from "../components/backlog/MyProjectManagement/managementDetail.vue";
import JoinProject from "../components/backlog/MyProjectManagement/join.vue";
import JoinProjectDetail from "../components/backlog/MyProjectManagement/joinDetail.vue";
import AduitProject from "../components/backlog/MyProjectManagement/aduit.vue";
import ProjectMembers from "../components/backlog/MyProjectManagement/projectMembers.vue";
import ProjectSettings from "../components/backlog/MyProjectManagement/projectSettings.vue";
import AuthoritySettings from "../components/backlog/MyProjectManagement/authoritySettings.vue";


// 资源管理
import DesktopDot from "../components/backlog/ResourcesManagement/desktopDot.vue";
import OnlineUser from "../components/backlog/ResourcesManagement/onlineUser.vue";
import CalculateDot from "../components/backlog/ResourcesManagement/calculateDot.vue";
import AddQueue from "../components/backlog/ResourcesManagement/addQueue.vue";
import TaskManangement from "../components/backlog/ResourcesManagement/taskManangement.vue";
import QueueManangement from "../components/backlog/ResourcesManagement/queueManangement.vue";
import UserAssignment from "../components/backlog/ResourcesManagement/userAssignment.vue";
import EditDesktopDot from "../components/backlog/ResourcesManagement/editDesktopDot.vue";
import EditCalculateDot from "../components/backlog/ResourcesManagement/editCalculateDot.vue";
import EditQueue from "../components/backlog/ResourcesManagement/editQueue.vue";
import EditTask from "../components/backlog/ResourcesManagement/editTask.vue";

// 用户管理
import UserManagement from "../components/backlog/UserManagement/list.vue";
import AddUser from "../components/backlog/UserManagement/addUser.vue";
import UserEditPassword from "../components/backlog/UserManagement/editPassword.vue";
import UserEditRole from "../components/backlog/UserManagement/editRole.vue";
import UserActivation from "../components/backlog/UserManagement/activation.vue";

// 平台监控
import PlatformMonitoring from "../components/backlog/PlatformMonitoring/list.vue";

// 应用管理
import ApplicationManagement from "../components/backlog/ApplicationManagement/list.vue";

// 个人中心
import UserCenter from "../components/backlog/UserCenter/index.vue"
import EditPassword from "../components/backlog/UserCenter/editPassword.vue";
import EditPhone from "../components/backlog/UserCenter/editPhone.vue";
import EditEmail from "../components/backlog/UserCenter/editEmail.vue";

// 系统设置
import RoleManagement from "../components/backlog/SystemSetting/roleManagement.vue";
import MenuManagement from "../components/backlog/SystemSetting/menuManagement.vue";
import LogManagement from "../components/backlog/SystemSetting/logManagement.vue";
import AuthManagement from "../components/backlog/SystemSetting/authManagement.vue";
import ThemeManagement from "../components/backlog/SystemSetting/themeManagement.vue";
import EditMenu from "../components/backlog/SystemSetting/editMenu.vue";
import SystemeManagement from "../components/backlog/SystemSetting/systemeManagement.vue";

// 联系我们
import Contact from "../components/backlog/Contact/contactPage.vue";

import NoPermission from '../components/backlog/NoPermission.vue';

Vue.use(VueRouter);

const routes = [
  {
    name:'index',
    path: "/",
    // redirect: "/workPlat" 
    redirect: "/login" 
  },
  {
    name:'login',
    path: "/login",
    component: Login
  },
  // 工作台
  { path: "/workPlat", 
    component: WorkPlat 
  },
  // 无权限
  { path: "/noPermission", 
    component: NoPermission 
  },
  {
    path: "/managerpage",
    component: ManagerPage,
    // 路由守卫
    beforeEnter: (to, from, next) => {
      const tokenStr = window.localStorage.getItem("token");
      if (!tokenStr) return next
    ("/login");
      next();
    },
    redirect: "/myDoc",
    children: [
      // 人员管理
      // 我的网盘
      { path: "/myDoc", component: MyDoc },
      { path: "/myShare", component: MyShare },
      { path: "/receiveShare", component: ReceiveShare },
      { path: "/patfromShare", component: PatfromShare },
      // 我的项目
      { path: "/managementProject", component: ManagementProject },
      { path: "/managementProjectDetail", component: ManagementProjectDetail },
      { path: "/joinProject", component: ManagementProject },
      { path: "/joinProjectDetail", component: ManagementProjectDetail },
      { path: "/aduitProject", component: AduitProject },
      { path: "/projectMembers", component: ProjectMembers },
      { path: "/projectSettings", component: ProjectSettings },
      { path: "/authoritySettings", component: AuthoritySettings },
      // 资源管理
      { path: "/desktopDot", component: DesktopDot },
      { path: "/onlineUser", component: OnlineUser },
      { path: "/calculateDot", component: CalculateDot },
      { path: "/addQueue", component: AddQueue },
      { path: "/taskManangement", component: TaskManangement },
      { path: "/queueManangement", component: QueueManangement },
      { path: "/userAssignment", component: UserAssignment },
      { path: "/editDesktopDot", component: EditDesktopDot },
      { path: "/editCalculateDot", component: EditCalculateDot },
      { path: "/editQueue", component: EditQueue },
      { path: "/editTask", component: EditTask },
      // 用户管理
      { path: "/userList", component: UserManagement },
      { path: "/userEdit", component: AddUser },
      { path: "/userEditPassword", component: UserEditPassword },
      { path: "/userEditRole", component: UserEditRole },
      { path: "/userActivation", component: UserActivation },
      // 平台监控
      { path: "/platformMonitoring", component: PlatformMonitoring },
      // 应用管理
      { path: "/applicationList", component: ApplicationManagement },
      // 个人中心
      { path: "/userCenter", component: UserCenter },
      { path: "/editPassword", component: EditPassword },
      { path: "/editPhone", component: EditPhone },
      { path: "/editEmail", component: EditEmail },
      
      // 系统设置
      { path: "/roleManagement", component: RoleManagement },
      { path: "/menuManagement", component: MenuManagement },
      { path: "/logManagement", component: LogManagement },
      { path: "/authManagement", component: AuthManagement },
      { path: "/themeManagement", component: ThemeManagement },
      { path: "/editMenu", component: EditMenu },
      { path: "/systemeManagement", component: SystemeManagement },
      // 联系我们
      { path: "/contactPage", component: Contact },
    ]
  },
];

const router = new VueRouter({
  mode: "history",
  routes
});

//抛出router之前，为其挂载路由导航守卫，to去哪，from从何来，next通行函数
// router.beforeEach((to, from, next) => {
//   if (to.path === "/login") return next();
//   const tokenStr = window.sessionStorage.getItem("token");
//   if (!tokenStr) return next("/login");
//   next();
// });

export default router;
